export const serviceProvidersData = [
  {
    id: '1',
    name: 'John Smith Plumbing',
    category: 'Plumbing',
    rating: 4.8,
    phoneNumber: '011 123 4567',
    address: '123 Main Street, Johannesburg',
    description: 'Professional plumbing services with 15 years experience',
    services: ['Leak Repairs', 'Drain Cleaning', 'Installation', 'Emergency Services'],
    reviews: [],
    availability: 'Mon-Sat: 8am-6pm',
    verified: true,
    imageUrl: '/images/plumbing.jpg'
  },
  {
    id: '2',
    name: 'Elite Electrical Solutions',
    category: 'Electrical',
    rating: 4.9,
    phoneNumber: '011 234 5678',
    address: '456 Park Avenue, Pretoria',
    description: 'Licensed electrical contractors for residential and commercial',
    services: ['Wiring', 'Installations', 'Maintenance', 'Emergency Repairs'],
    reviews: [],
    availability: 'Mon-Sun: 24/7',
    verified: true,
    imageUrl: '/images/electrical.jpg'
  },
  {
    id: '3',
    name: 'Master Carpentry',
    category: 'Carpentry',
    rating: 4.7,
    phoneNumber: '011 345 6789',
    address: '789 Wood Street, Sandton',
    description: 'Custom woodwork and furniture repairs',
    services: ['Custom Furniture', 'Repairs', 'Installations', 'Wood Restoration'],
    reviews: [],
    availability: 'Mon-Fri: 9am-5pm',
    verified: true,
    imageUrl: '/images/carpentry.jpg'
  },
  {
    id: '4',
    name: 'Perfect Paint Pro',
    category: 'Painting',
    rating: 4.6,
    phoneNumber: '011 456 7890',
    address: '321 Color Road, Randburg',
    description: 'Interior and exterior painting services',
    services: ['Interior Painting', 'Exterior Painting', 'Wallpaper', 'Color Consulting'],
    reviews: [],
    availability: 'Mon-Sat: 7am-6pm',
    verified: true,
    imageUrl: '/images/painting.jpg'
  }
]; 